import { Component, input } from '@angular/core';
import { AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'htx-textarea-field',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './textarea-field.component.html',
  styleUrl: './textarea-field.component.scss'
})
export class TextareaFieldComponent {
  private uniqueId = Math.random().toString(36).substring(2, 11);

  /** FormControl instance for managing the textarea's value and validation state */
  ctrl = input.required<AbstractControl>();

  /** Label text displayed above the textarea */
  label = input<string>();

  /** Whether to display a required indicator (*) next to the label */
  required = input<boolean>(false);

  /** Number of rows for the textarea (default: 10) */
  rows = input<number>(10);

  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }

  getUniqueId(): string {
    return this.uniqueId;
  }
}
